import { render, staticRenderFns } from "./RightDeliveryWarehouse.vue?vue&type=template&id=2fc745d3"
import script from "./RightDeliveryWarehouse.vue?vue&type=script&lang=js"
export * from "./RightDeliveryWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc745d3')) {
      api.createRecord('2fc745d3', component.options)
    } else {
      api.reload('2fc745d3', component.options)
    }
    module.hot.accept("./RightDeliveryWarehouse.vue?vue&type=template&id=2fc745d3", function () {
      api.rerender('2fc745d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/AppointDelivery/parcel/RightDeliveryWarehouse.vue"
export default component.exports